<template>
    <div class="panel">
        <h3>Auth data</h3>

        <Checkbox v-model="auth.enabled" density="compact"> Use fake user </Checkbox>

        <TransitionExpand>
            <div class="panel-count" v-if="auth.enabled">
                <Notification icon="InfoCircle">
                    Remember that fake user is not represented in the Header
                </Notification>
                <div>
                    <Checkbox v-model="auth.member.canBeSembonusUser" density="compact">
                        Can be Sembonus user
                    </Checkbox>

                    <Checkbox v-model="auth.member.isSembonusUser" density="compact">
                        Is Sembonus user
                    </Checkbox>

                    <Checkbox v-model="checkout.hasBonusNights" density="compact">
                        Has bonus nights
                    </Checkbox>
                </div>
            </div>
        </TransitionExpand>
    </div>
</template>

<script lang="ts">
    import { defineComponent, PropType } from 'vue';
    import { FakeDataAuth, FakeDataCheckout } from '../DevPanel.interfaces';
    import Checkbox from '@ui/components/FormV2/Fields/Checkbox/Checkbox.vue';
    import TransitionExpand from '@ui/components/TransitionExpand/TransitionExpand.vue';
    import Notification from '@ui/components/Notification/Notification.vue';

    export default defineComponent({
        name: 'AuthPanel',
        components: { Checkbox, TransitionExpand, Notification },
        props: {
            auth: { type: Object as PropType<FakeDataAuth>, required: true },
            checkout: { type: Object as PropType<FakeDataCheckout>, required: true },
        },
    });
</script>

<style lang="scss">
    @forward './Panel.scss';
</style>
